module.exports = __webpack_public_path__ + "img/s6.1aeae9c7.png";